<template>
    <div>
        <b-row>
            <b-col>
                <slot name="field"></slot>
            </b-col>
            <b-col sm="1" md="1" lg="1" @click="popup = true" class="seeHelpfulTip">
                <i class="fa fa-info-circle fa-lg  align-middle mt-5"></i>
                <b-modal :title="title" v-model="popup" ok-only>
                    <slot name="modal"></slot>
                </b-modal>
            </b-col>
        </b-row>
    </div>
</template>


<style scoped>
.seeHelpfulTip {
    cursor: pointer;
}
</style>

<script>
export default {
    name: "HelptipPopup",
    props: {
        title: {
            type: String,
            default: 'Did you know?'
        }
    },
    data: function() {
        return {
            popup: false
        }
    },
    computed: {}
}
</script>